<script setup lang="ts">
import { inject, onMounted, ref, type Ref } from 'vue'
import CContentQuizView from '@/presentation/components/content/CContentQuizView.vue'
import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'

const dialogRef: any = inject('dialogRef')
const blocks: Ref<Record<string, QuizVersion>> = ref({})
const title: Ref<string> = ref('')

onMounted(() => {
  title.value = dialogRef.value?.data?.title
  blocks.value = dialogRef.value?.data?.blocks
})
</script>

<template>
  <div class="flex flex-col justify-start gap-4">
    <h3 class="flex-1">{{ title }}</h3>

    <c-content-quiz-view
      v-for="(version, key) in blocks"
      :key="`quiz_${version.quizId}_version_${version.id}`"
      :subtitle="key"
      :quiz-version="version"
    />
  </div>
</template>
